// extracted by mini-css-extract-plugin
export default {"melodyVideo":"PJ-z","isFullWidth":"QJ-z","landingPageVideo":"RJ-z","play":"SJ-z","iframeVideo":"TJ-z","playHidden":"UJ-z","fullwidth":"VJ-z"};